import * as actionTypes from "./actionTypes";
import { storeService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function resetStores() {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESET_STORES });
  };
}

export function getStores({
  page = constants.GET_ALL_ITEMS,
  filter = "",
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_STORES });

      dispatch({ type: actionTypes.FETCH_STORES });

      const response = await storeService.getAll(page, filter);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_STORES_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_STORES_SUCCESS,
        payload: {
          stores: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_STORES_FAILURE);
    }
  };
}

export function getStore(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_STORE });
      dispatch({ type: actionTypes.FETCH_STORE });

      const response = await storeService.get(id);
      const data = response.data;
      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_STORE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_STORE_SUCCESS,
        payload: { store: data },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_STORE_FAILURE);
    }
  };
}
export function resetStore() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_STORE,
    });
  };
}

export function createStore(store) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CREATE_STORE });

      const response = await storeService.create(store);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CREATE_STORE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.CREATE_STORE_SUCCESS,
        payload: {
          store: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CREATE_STORE });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CREATE_STORE_SUCCESS);
    }
  };
}
export function resetCreateStore() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_CREATE_STORE,
    });
  };
}
export function updateStore(id, store) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPDATE_STORE });

      const response = await storeService.update(id, store);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.UPDATE_STORE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.UPDATE_STORE_SUCCESS,
        payload: { store: data },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.UPDATE_STORE_FAILURE);
    }
  };
}
export function resetUpdateStore() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATE_STORE,
    });
  };
}
export function deleteStore(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_STORE });

      const response = await storeService.deleteStore(id);

      dispatch({
        type: actionTypes.DELETE_STORE_SUCCESS,
        payload: {
          store: { id },
        },
      });

      dispatch({ type: actionTypes.RESET_DELETE_STORE });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.DELETE_STORE_FAILURE);
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/store/actions.js